module.exports = __webpack_public_path__ + "static/media/gallery-4.f48fae28.png";